module.exports = __webpack_public_path__ + "img/background018.jpg";